/*import "./modernizr-min.js"; // Not required anymore (Breaks customizer)*/
/*import "./jquery.validate.min.js"; // Only required for blog post comment forms*/
/*import "./comment-form-validation.js"; // Only required for blog post comment forms*/
import "./custom.js";

// Import Swiper and styles
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

Swiper.use([Autoplay, Navigation, Pagination]);


// Init Swiper when needed
document.addEventListener('DOMContentLoaded', function () {
	
	const testimonialCarousel = document.querySelector('.testimonial-carousel');
	
	if (testimonialCarousel) {
		const swiper = new Swiper(testimonialCarousel, {
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			slidesPerView: 2.2,
			slidesPerGroup: 2,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
		
		setTimeout(() => {
			swiper.slideToLoop(2, 0); // no animation
			swiper.autoplay.start();
		}, 50);
	}
});
